/**
 * Brief Templates by Business Niche
 * Pre-filled brief data to help users start quickly
 */

export const BRIEF_TEMPLATES = [
  {
    id: 'coach_infoproductos',
    name: 'Coach / Infoproductos',
    icon: '🎯',
    description: 'Mentorías, cursos digitales, programas de transformación',
    color: 'from-violet-500 to-purple-500',
    brief: {
      product_name: 'Método Despierta',
      product_type: 'curso_online',
      product_description: 'Programa de 8 semanas para coaches y terapeutas que quieren vivir de su pasión. Incluye mentoría grupal, plantillas de contenido, y acceso a comunidad privada.',
      target_audience: 'Coaches, terapeutas y profesionales del desarrollo personal entre 30-50 años que tienen conocimiento pero no saben cómo monetizarlo online. Frustrados por no tener clientes estables.',
      main_promise: 'Consigue tus primeros 10 clientes de pago en 60 días con un sistema probado, sin necesidad de ser influencer ni tener miles de seguidores.',
      pain_points: 'No saben cómo atraer clientes de forma consistente. Sienten que regalan su tiempo en sesiones gratis. Les da vergüenza vender o poner precios altos. No tienen sistema de captación.',
      main_objections: 'No tengo tiempo. Ya he probado otros cursos. No soy bueno con la tecnología. No tengo dinero para invertir.',
      price: '997',
      currency: 'EUR',
      tone_of_voice: 'cercano',
      expert_name: 'María González',
      bonuses: 'Pack de plantillas de contenido, 3 sesiones de mentoría 1:1, Acceso de por vida a actualizaciones',
      dias_garantia: '14',
      cuenta_atras_oferta: '72'
    }
  },
  {
    id: 'ecommerce',
    name: 'Ecommerce / Producto Físico',
    icon: '🛍️',
    description: 'Tiendas online, productos físicos, dropshipping',
    color: 'from-emerald-500 to-teal-500',
    brief: {
      product_name: 'Almohada ErgoSleep Pro',
      product_type: 'producto_fisico',
      product_description: 'Almohada cervical de espuma viscoelástica con gel refrigerante. Diseño ergonómico aprobado por fisioterapeutas. Funda lavable de bambú hipoalergénico.',
      target_audience: 'Adultos de 35-55 años con problemas de cuello o espalda, trabajadores de oficina, personas que pasan muchas horas frente al ordenador. Valoran calidad y descanso.',
      main_promise: 'Despierta sin dolor de cuello ni rigidez. La única almohada recomendada por más de 500 fisioterapeutas en España.',
      pain_points: 'Se despiertan con dolor de cuello. No encuentran una almohada cómoda. Han probado muchas y ninguna funciona. El dolor afecta su productividad.',
      main_objections: 'Ya tengo una almohada buena. Son muy caras. No creo que una almohada cambie nada. Prefiero probarla antes de comprar.',
      price: '89',
      currency: 'EUR',
      tone_of_voice: 'profesional',
      shipping_conditions: 'Envío gratis en 24-48h. Devolución gratuita en 30 días.',
      discount_percent: '20',
      dias_garantia: '30',
      cuenta_atras_oferta: '24'
    }
  },
  {
    id: 'agencia_servicios',
    name: 'Agencia / Servicios',
    icon: '💼',
    description: 'Agencias de marketing, consultorías, servicios B2B',
    color: 'from-blue-500 to-cyan-500',
    brief: {
      product_name: 'Programa Escala Digital',
      product_type: 'servicio',
      product_description: 'Servicio de marketing digital llave en mano para negocios locales. Incluye gestión de redes sociales, campañas de publicidad, y posicionamiento SEO local.',
      target_audience: 'Dueños de negocios locales (restaurantes, clínicas, gimnasios, tiendas) de 35-55 años que facturan entre 100K-500K€/año y quieren crecer pero no tienen tiempo ni conocimientos de marketing.',
      main_promise: 'Duplica tus clientes en 90 días con nuestro sistema de marketing digital probado en +200 negocios locales.',
      pain_points: 'No tienen tiempo para gestionar sus redes. Han contratado community managers sin resultados. No entienden de publicidad online. Dependen del boca a boca.',
      main_objections: 'Ya he contratado agencias antes sin resultados. Es muy caro. No tengo tiempo para reuniones. Mi negocio es diferente.',
      price: '1.497',
      currency: 'EUR',
      tone_of_voice: 'profesional',
      expert_name: 'Carlos Martín',
      bonuses: 'Auditoría digital gratuita, Plan de contenidos 3 meses, Soporte prioritario por WhatsApp',
      dias_garantia: '30',
      cuenta_atras_oferta: '48'
    }
  },
  {
    id: 'saas_software',
    name: 'SaaS / Software',
    icon: '💻',
    description: 'Aplicaciones, herramientas digitales, plataformas',
    color: 'from-indigo-500 to-blue-500',
    brief: {
      product_name: 'TaskFlow Pro',
      product_type: 'saas',
      product_description: 'Plataforma de gestión de proyectos y tareas para equipos remotos. Incluye tableros Kanban, seguimiento de tiempo, integraciones con +50 apps, y reportes automáticos.',
      target_audience: 'CEOs y managers de startups y PYMEs de 10-50 empleados. Equipos remotos o híbridos que necesitan coordinar proyectos. Frustrados con herramientas complicadas o dispersas.',
      main_promise: 'Gestiona todos tus proyectos en un solo lugar. El 94% de nuestros usuarios recuperan +5 horas semanales.',
      pain_points: 'Usan demasiadas herramientas diferentes. Pierden tiempo buscando información. No tienen visibilidad del progreso. Los proyectos se retrasan.',
      main_objections: 'Ya usamos Trello/Asana. Migrar es complicado. Mi equipo no va a adoptarlo. Es otro gasto más.',
      price: '29',
      currency: 'EUR',
      tone_of_voice: 'profesional',
      core_features: 'Tableros ilimitados, Automatizaciones, Integraciones, App móvil, Soporte 24/7',
      dias_garantia: '14',
      cuenta_atras_oferta: '168'
    }
  },
  {
    id: 'formacion_cursos',
    name: 'Formación / Cursos Online',
    icon: '📚',
    description: 'Academias online, formación profesional, bootcamps',
    color: 'from-amber-500 to-orange-500',
    brief: {
      product_name: 'Bootcamp Data Analytics',
      product_type: 'curso_online',
      product_description: 'Formación intensiva de 12 semanas para convertirte en Data Analyst. Clases en directo, proyectos reales con empresas, y bolsa de empleo. Sin conocimientos previos necesarios.',
      target_audience: 'Profesionales de 25-40 años en transición de carrera o queriendo mejorar su perfil. Administrativos, marketers, o recién graduados que quieren trabajar en tech con mejores sueldos.',
      main_promise: 'Consigue trabajo como Data Analyst en 6 meses o te devolvemos el dinero. Salario medio de entrada: 32.000€.',
      pain_points: 'Estancados en trabajos sin futuro. Quieren mejores sueldos. No saben por dónde empezar. Les intimida la programación.',
      main_objections: 'No tengo tiempo con mi trabajo actual. Es muy caro. No sé si tengo capacidad. Hay muchos cursos gratis.',
      price: '2.997',
      currency: 'EUR',
      tone_of_voice: 'motivador',
      expert_name: 'Tech Academy',
      bonuses: 'Certificación oficial, Portfolio con 5 proyectos reales, 6 meses de bolsa de empleo, Mentorías 1:1',
      dias_garantia: '14',
      cuenta_atras_oferta: '72'
    }
  },
  {
    id: 'salud_bienestar',
    name: 'Salud / Bienestar / Estética',
    icon: '🧘',
    description: 'Clínicas, centros de bienestar, nutricionistas, fitness',
    color: 'from-rose-500 to-pink-500',
    brief: {
      product_name: 'Método Reset Metabolico',
      product_type: 'servicio',
      product_description: 'Programa de 90 días de nutrición y ejercicio personalizado. Incluye plan alimenticio, rutinas de entrenamiento, seguimiento semanal con nutricionista, y acceso a app exclusiva.',
      target_audience: 'Mujeres de 35-50 años que han probado muchas dietas sin éxito duradero. Quieren perder peso de forma saludable sin pasar hambre. Valoran el acompañamiento profesional.',
      main_promise: 'Pierde de 8 a 12 kilos en 90 días comiendo de todo, sin contar calorías, y sin efecto rebote.',
      pain_points: 'Han hecho mil dietas y siempre recuperan el peso. Se sienten agotadas y sin energía. No tienen tiempo para ir al gimnasio. Les cuesta ser constantes solas.',
      main_objections: 'Las dietas no funcionan conmigo. Es muy caro. No tengo fuerza de voluntad. Ya lo he intentado todo.',
      price: '497',
      currency: 'EUR',
      tone_of_voice: 'cercano',
      expert_name: 'Dra. Ana López',
      bonuses: 'Recetario de 100 recetas rápidas, Guía de compras del supermercado, Comunidad privada de apoyo',
      dias_garantia: '14',
      cuenta_atras_oferta: '48'
    }
  }
];

/**
 * Demo funnel data - A complete example funnel for the onboarding "Ver un ejemplo"
 * This is the structure that will be seeded in the database
 */
export const DEMO_FUNNEL_DATA = {
  id: 'demo-funnel-fascinai',
  name: 'Funnel Demo - Método Despierta',
  client_name: 'Demo FASCINAI',
  is_demo: true,
  readonly: true,
  status: 'completed',
  strategy: 'lanzamiento',
  variant: '1_solo_directo',
  brief: BRIEF_TEMPLATES[0].brief, // Uses Coach template
  assets: {
    // Landing page
    landingCaptacion: {
      title: 'Método Despierta - Vive de tu pasión como coach',
      content: `<section class="hero">
        <h1>Consigue tus primeros 10 clientes de pago en 60 días</h1>
        <p>El sistema probado para coaches y terapeutas que quieren vivir de su pasión sin ser influencers</p>
        <button>Reserva tu plaza</button>
      </section>`,
      generated: true
    },
    // Email sequence
    emailsCaptacion: [
      {
        id: 'email_1',
        subject: '¿Cansado/a de regalar tu tiempo?',
        content: 'Hola {nombre},\n\nSé lo que es tener un don para ayudar a otros pero no saber cómo convertirlo en un negocio rentable...',
        type: 'captacion',
        order: 1
      },
      {
        id: 'email_2', 
        subject: 'El error que cometen el 90% de coaches',
        content: 'Hola {nombre},\n\nAyer te hablé sobre el problema de regalar tu tiempo. Hoy quiero contarte el error más común...',
        type: 'captacion',
        order: 2
      },
      {
        id: 'email_3',
        subject: 'María facturó 8.000€ en su primer mes',
        content: 'Hola {nombre},\n\nQuiero presentarte a María, una de mis alumnas que hace 6 meses estaba exactamente donde tú...',
        type: 'captacion',
        order: 3
      }
    ],
    // Ad copies
    adsCopyCaptacion: [
      {
        id: 'copy_1',
        angulo: 'Transformación',
        headline: '¿Coach sin clientes? Esto te interesa',
        primary_text: 'Pasa de dar sesiones gratis a tener una agenda llena de clientes que pagan lo que vales. Sin necesitar miles de seguidores.',
        cta: 'Más información'
      },
      {
        id: 'copy_2',
        angulo: 'Dolor',
        headline: 'El problema de ser coach en 2024',
        primary_text: 'Tienes el conocimiento para transformar vidas pero no sabes cómo atraer clientes de forma consistente. ¿Te suena?',
        cta: 'Descubre cómo'
      }
    ],
    // Creativities (placeholder URLs)
    creativos: [
      {
        id: 'creativo_1',
        tipo: 'imagen',
        formato: '4:5',
        headline: 'Vive de tu pasión como coach',
        motor: 'flux_pro',
        asset_url: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=1080&h=1350&fit=crop'
      },
      {
        id: 'creativo_2',
        tipo: 'imagen',
        formato: '9:16',
        headline: '10 clientes en 60 días',
        motor: 'flux_pro',
        asset_url: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1080&h=1920&fit=crop'
      }
    ]
  },
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};

export default BRIEF_TEMPLATES;
